module.exports = __webpack_public_path__ + "img/230.2ccfe87e.jpg";